import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"

import { BackgroundKeyToColor, GeneralSizeKeyToPaddingNumber } from "../../../utils/datasources"
import * as styles from "./IconTablePanel.module.scss"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"



const IconTablePanel = ({ blok }) => {
  const cardPaddingTop = GeneralSizeKeyToPaddingNumber(blok.card_padding_top),
        cardPaddingBottom = GeneralSizeKeyToPaddingNumber(blok.card_padding_bottom),
        cardBackgroundColor = BackgroundKeyToColor(blok.card_background_color)
  return (
    <PanelWrapper blok={blok}>
      <Container className={`panel-radius shadow-cards ${styles.wrapper}`} style={{backgroundColor: cardBackgroundColor, paddingTop: cardPaddingTop, paddingBottom: cardPaddingBottom}}>
        <h3 className={styles.headline}>{blok.headline}</h3>
        <div className={styles.content}>
          {blok.body.map((iconTableRow)=>{
            if(iconTableRow.component === "icon_table_row") {
              return (
                <div key={iconTableRow._uid} className={styles.iconRow}>
                  <Row xs={12}>
                    <Col xs={12} xl={2} className={styles.iconCol}>
                      <h4>{iconTableRow.name}</h4>
                    </Col>
                    <Col xs={12} xl={true}>
                      <Row>
                        {iconTableRow.body.map((iconItem)=>{
                          return (
                            <Col xs={12} md={6} xl={4} key={iconItem._uid} className={styles.iconItem}>
                              <div className={styles.iconItemIcon}>
                                <StoryblokImage sbImageData={iconItem.icon} />
                              </div>
                              <div className={styles.iconItemText}>{iconItem.text}</div>
                              <div style={{clear: "both"}}></div>
                            </Col>
                          )
                        })}
                      </Row>
                    </Col>
                  </Row>
                </div>
              )
            }
            return null
          })}
        </div>
      </Container >
    </PanelWrapper>
  )
}

export default IconTablePanel